import "./ResearchInformation.module.css";
import Header from "@/reusable_sections/Header";
import ResearchOverview from "./sections/ResearchOverview";
import Domains from "./sections/Domains";
import Compliance from "./sections/Compliance";
import Footer from "@/reusable_sections/Footer";
export default function ResearchInformationPage() {
  return <div>
      <Header />
      <ResearchOverview />
      <Domains />
      <Compliance />
      <Footer />
    </div>;
}